import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';

// Translator.
import { TranslateService, TranslatePipe, TranslateModule } from '@ngx-translate/core';

// Services.
import { ServiceTypesService } from '../../../services/serviceTypes.service';
import { ClientDivisionsService } from '../../../services/clientDivisions.service';

// Models.
import { ServiceType } from '../../../models/serviceType';
import { VW_ClientDivision } from '../../../models/RES/vwClientDivision';

// Material.
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

@Component({
  selector: 'app-request-type-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatRadioModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    TranslateModule,
    TranslatePipe,
    NgxSpinnerModule
  ],
  templateUrl: './request-type-dialog.component.html',
  styleUrl: './request-type-dialog.component.scss'
})
export class RequestTypeDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<RequestTypeDialogComponent>,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public translate: TranslateService,
    private apiST: ServiceTypesService,
    private apiCD: ClientDivisionsService
  ){
    this.candidateForm = this.fb.group({
      serviceType_Id: [null, Validators.required],
      division_Id: [null, Validators.required],
      name: ['', Validators.required],
      firstLastName: ['', Validators.required],
      secondLastName: ['']
    });
  }
  router = inject(Router);
  private _snackBar = inject(MatSnackBar);

  candidateForm: FormGroup;
  serviceTypes: ServiceType[] = [];
  divisions: VW_ClientDivision[] = [];
  selectedTypeId: number | null = null;

  ngOnInit(): void {
    this.LoadData();
  }

  public LoadData(){
    this.spinner.show();
    this.apiST.GetServiceTypesByCognitoUser().subscribe({
      next: (response) => {
        this.spinner.hide();
        if (response.success === 1) {
          this.serviceTypes = response.data;

          this.apiCD.GetClientDivisionsByCognitoUser().subscribe({
            next: (response) => {
              if (response.success === 1) {
                this.divisions = response.data;
              } else {
                this.openSnackBar(response.message);
              }
            },
            error: (error) => {
              const statusCode = error.status;
              const errorMessage = error.error?.message || "An error occurred trying to connect to web services.";
        
              this.openSnackBar(`Error ${statusCode}: ${errorMessage}`);
              console.error(`Error ${statusCode}`, error);
            },
          });
        } else {
          this.openSnackBar(response.message);
        }
      },
      error: (error) => {
        this.spinner.hide();
        const statusCode = error.status;
        const errorMessage = error.error?.message || "An error occurred trying to connect to web services.";
  
        this.openSnackBar(`Error ${statusCode}: ${errorMessage}`);
        console.error(`Error ${statusCode}`, error);
      },
    });
  }

  onSubmit(): void {
    if (this.candidateForm.valid) {
      const formData = this.candidateForm.value;

      this.dialogRef.close(formData);
    } else {
      this.openSnackBar("Please complete all required fields.");
    }
  }

  public continue() {
    if (this.selectedTypeId !== null) {
      this.closeDialog();
      this.router.navigate(['/newRequest'], { queryParams: { typeId: this.selectedTypeId } });
    } else {
      this.openSnackBar("No service type selected.");
    }
  }

  closeDialog(){
    this.dialogRef.close(false);
  }

  openSnackBar(Message: string) {
    this._snackBar.open(Message, "Disiss", { duration: 5000 });
  }
}

// Fuck you Nicole!